import React, { useState, useEffect } from "react";
import ACpricingConfig from "./pricingConfig";

export default function ACdetails({ setShowSavedItems, showSavedItems, onACDetailsChange, savedItems, setSavedItems, acDetails, setACDetails, setCassetteInstallationCharge, setSplitInstallationCharge, cassetteInstallationCharge, splitInstallationCharge }) {
  const [modalACDetails, setModalACDetails] = useState(false);

  useEffect(() => {
    // Call updatePricing only when acDetails.plan, acDetails.ton, or acDetails.acType changes
    updatePricing();
  }, [acDetails.plan, acDetails.ton, acDetails.acType]);
  
  useEffect(() => {
    // Call updateHandler only when quantity is greater than 1
   
      updateHandler();
    
  }, [acDetails.quantity]);
  
  const updatePricing = () => {
    let { acType, ton, plan } = acDetails;
    const quantity = 1; // Default quantity for pricing calculation
  
    if (acType === "Split" && ton === "10" && plan === "5years") {
      plan = "3+2year";
    }
  
    const pricingDetails = ACpricingConfig[acType]?.[ton]?.[plan];
  
    if (!pricingDetails) {
      console.error("Invalid configuration for AC type, ton, or plan");
      return;
    }
  
    const { subscription, priceAfter3Years, installetionCharge, depositamount } = pricingDetails;
  
    const totalSubscription = subscription * quantity;
    const totalDeposit = depositamount * quantity;
    const totalInstallation = installetionCharge * quantity;
    const totalAfter3Years = priceAfter3Years * quantity;
  
    const totalAmount = totalSubscription + totalDeposit + totalInstallation;
  
    const itemId = `mc_${plan === "3year" ? "3" : plan === "5years" ? "5" : "3+2"}y_${ton.replace(" ", "_")}`;
  
    const updatedDetails = {
      ...acDetails,
      subscription_plan: subscription,
      depositamount: depositamount,
      installetionCharge: installetionCharge,
      itemId: itemId,
      totalSubscription: totalSubscription,
      totalDeposit: totalDeposit,
      totalInstallation: totalInstallation,
      priceAfter3Years: priceAfter3Years,
      totalAfter3Years: totalAfter3Years,
      totalAmount: totalAmount,
    };
  
    setACDetails(updatedDetails);
    onACDetailsChange(updatedDetails);
  };
  
  const updateHandler = () => {
    const totalSubscription = parseInt(acDetails.subscription_plan) * parseInt(acDetails.quantity);
    const totalDeposit = parseInt(acDetails.depositamount) * parseInt(acDetails.quantity);
    const totalInstallation = parseInt(acDetails.installetionCharge) * parseInt(acDetails.quantity);
    const totalAfter3Years = parseInt(acDetails.priceAfter3Years) * parseInt(acDetails.quantity);
  
    const totalAmount = totalSubscription + totalDeposit + totalInstallation;
  
    const updatedDetails = {
      ...acDetails,
      totalSubscription: totalSubscription,
      totalDeposit: totalDeposit,
      totalInstallation: totalInstallation,
      totalAfter3Years: totalAfter3Years,
      totalAmount: totalAmount,
    };
  
    setACDetails(updatedDetails);
    onACDetailsChange(updatedDetails);
  };
  




  const handleBlur1 = (e) => {
    const { id, value } = e.target;
    let newValue = value === '' ? null : Number(value);

    if (id === "installetionCharge") {
      const acType = acDetails.acType;

      // If AC type is Split, check if the value is in the range 1500-1800
      // if (acType === "Split") {
      //   if (newValue < 1200) {
      //     alert(`The installation charge for Split AC should be more then 1199. Current value: ${newValue}`);
      //     return
      //   }
      // }
      // // If AC type is Cassette, check if the value is in the range 3500-4000
      // else if (acType === "Cassette") {
      //   if (newValue < 3500) {
      //     alert(`The installation charge for Cassette AC should be at least  3500 . Current value: ${newValue}`);
      //     return
      //   }
      // }
      // For other AC types, check if the value is at least 1500
 
      updateHandler()
    }
    
  };


  const handleBlur2 = (e) => {
    const { id, value } = e.target;
    let newValue = value === '' ? null : Number(value);
    if (id === "depositamount") {
      const acType = acDetails.acType;

      // If AC type is Split, check if the value is in the range 1500-1800
      // if (acType === "Split") {
      //   if (newValue < 5000) {
      //     alert(`The depositamount charge for Split AC should be morethan 4999 . Current value: ${newValue}`);
      //     return
      //   }
      // }else if(acType==="Cassette"){
      //   if(newValue<12000){
      //     alert(`The depositamount charge for Cassette AC should be morethan 11999 . Current value: ${newValue}`);
      //     return
      //   }
      // }

      updateHandler()
    }
   
  };

  const handleBlur3 = (e) => {
    const { id, value } = e.target;
    let newValue = value === '' ? null : Number(value);
  
    // Destructure required details from acDetails
    const { acType, ton, plan } = acDetails;
  
    if (id === "subscription_plan") {
      // Fetch the predefined subscription value from ACpricingConfig
      const predefinedSubscription = ACpricingConfig[acType]?.[ton]?.[plan]?.subscription;
  
      if (predefinedSubscription === undefined) {
        console.error("Invalid configuration for AC type, ton, or plan.");
        return;
      }
  
      // Check if the entered value is less than the predefined value
  
  
      // Update the subscription plan with the validated value
      updateHandler()
    }
  };
  




  const handleChange = (e) => {
    const { id, value } = e.target;
    let newValue = value;

    switch (id) {
      case "quantity":
        // Allow the input to be empty or only valid numbers
        if (newValue === '' || /^[0-9\b]+$/.test(newValue)) {
          newValue = newValue === '' ? null : parseInt(newValue, 10);
        }
        break;

      case "discountamount":
      case "discountpercent":
        newValue = value === '' ? null : parseFloat(value);
        break;

      case "acType":
        newValue = value;

        // Determine the appropriate installation charge based on the AC type
        let newInstalletionCharge;

        if (value === "Split") {
          newInstalletionCharge = (acDetails.installetionCharge == null)
            ? 1800 // Default to minimum if out of range or null
            : acDetails.installetionCharge; // Keep current value if valid
        } else if (value === "Cassette") {
          newInstalletionCharge = ( acDetails.installetionCharge == null)
            ? 4000 // Default to minimum if out of range or null
            : acDetails.installetionCharge; // Keep current value if valid
        } else {
          newInstalletionCharge = acDetails.installetionCharge || 1500; // Default to 1500 if other types
        }

        setACDetails(prevDetails => ({
          ...prevDetails,
          [id]: newValue, // Update acType
          ton: value === "Split" ? "10" : "20", // Update ton based on acType
          plan: value === "Cassette" ? "3+2year" : "3+2year", // Update plan based on acType
          installetionCharge: newInstalletionCharge, // Set installation charge based on acType
        }));
        return; // Directly return here to avoid setting the state again later

      case "installetionCharge":
        newValue = value === '' ? null : Number(value);
        break;

      default:
        break;
    }

    // Set state with the validated new value
    setACDetails(prevDetails => ({
      ...prevDetails,
      [id]: newValue,
    }));
  };

  const handleBlur = () => {
    // Ensure the quantity is at least 1 on blur
    if (acDetails.quantity === null || acDetails.quantity <= 0) {
      setACDetails(prevDetails => ({
        ...prevDetails,
        quantity: 1, // Set to 1 if empty or less than 1
      }));
    }
  };


  const handleSave = () => {
    updateHandler()
    const newSavedItems = [...savedItems, { ...acDetails, id: Date.now() }];


    
    setSavedItems(newSavedItems);
    setShowSavedItems(true);
    setModalACDetails(false);
    setACDetails({
      acType: "Split",
      ton: "10",
      plan: "3+2year",
      quantity: 1,
      subscription_plan: 1349,
      depositamount: 5000,
      installetionCharge: 1800,
      totalSubscription: 1349,
      totalDeposit: 5000,
      totalInstallation: 1800,
      priceAfter3Years: 899,
      totalAfter3Years: 899,
      totalAmount: 8149
    
    });
    onACDetailsChange({
      acType: "Split",
      ton: "10",
      plan: "3+2year",
      quantity: 1,
      subscription_plan: 1349,
      depositamount: 5000,
      installetionCharge: 1800,
      totalSubscription: 1349,
      totalDeposit: 5000,
      totalInstallation: 1800,
      priceAfter3Years: 899,
      totalAfter3Years: 899,
      totalAmount: 8149
   
    });
    window.scrollTo(0, 0);
  };

  const handleRemove = (id) => {
    const updatedItems = savedItems.filter((item) => item.id !== id);
    setSavedItems(updatedItems);
  };

  const availableTons = acDetails.acType === "Split"
    ? [
      { value: "10", label: "1.0" },
      { value: "15", label: "1.5" },
      { value: "20", label: "2.0" },
    ]
    : [
      { value: "20", label: "2.0" },
      { value: "30", label: "3.0" },
    ];

  const availablePlans = acDetails.acType === "Cassette"
    ? [{ value: "3+2year", label: "3+2 Year" }]
    : [
      { value: "3year", label: "3 Year" },
      { value: "3+2year", label: "3+2 Year" },
      { value: "5years", label: "5 Year" },
    ];





  return (
    <div className="bg-white shadow-md rounded-xl border-2 p-6">
      <h1 className="font-semibold text-lg">AC Details <span style={{ color: "red" }}>*</span></h1>
      {showSavedItems && (
        <div className="flex flex-wrap gap-4 mt-4">
          {savedItems.map((item) => (
            <div
              key={item.id}
              className="border border-primary p-4 rounded-2xl w-full sm:w-1/2 md:w-1/3 lg:w-1/4 xl:w-1/5 min-h-72 flex flex-col justify-between"
            >
              <h3 className="font-semibold">
                {item.acType} AC - {item.ton === '10' ? '1' : item.ton === '15' ? '1.5' : item.ton === '20' ? '2' : item.ton === '30' ? '3.0' : item.ton} Ton
              </h3>
              <p>Plan: {item.plan}</p>
              <p>Quantity: {item.quantity}</p>
              <p>Total Installation: {item.totalInstallation}</p>
              <p>Subscription for M1 to M36: {item.totalSubscription}</p>
              <p>Refundable Deposit: {item.totalDeposit}</p>
              {item.plan === "3+2year" && (
                <>
                  <p>Subscription for M37 to M60 : {item.totalAfter3Years / item.quantity}</p>
                  <p>Total After 3 Years: {item.totalAfter3Years}</p>
                </>
              )}
              <p>
                <strong> Total Amount: {item.totalAmount}</strong>
              </p>
             
              <button
                onClick={() => handleRemove(item.id)}
                className="mt-4 bg-red-500 text-white font-normal py-2 px-4 rounded"
              >
                Remove
              </button>
            </div>
          ))}
        </div>
      )}

      {!modalACDetails && (
        <button className="mt-6 border border-primary py-2 px-4 text-primary rounded-lg hover:text-white hover:bg-primary" onClick={() => setModalACDetails(true)}>
          + Add an AC
        </button>
      )}
      {modalACDetails && (
        <div className="mt-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-6">
            <div>
              <label htmlFor="acType" className="block font-semibold mb-2">AC type:</label>
              <select id="acType" className="w-full border-2 border-gray-300 rounded py-2 px-4" value={acDetails.acType} onChange={handleChange} >
                <option value="Split">Split</option>
                <option value="Cassette">Cassette</option>
              </select>
            </div>
            <div>
              <label htmlFor="ton" className="block font-semibold mb-2">Ton:</label>
              <select id="ton" className="w-full border-2 border-gray-300 rounded py-2 px-4" value={acDetails.ton} onChange={handleChange}>
                {availableTons.map((ton) => (
                  <option key={ton.value} value={ton.value}>{ton.label}</option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="plan" className="block font-semibold mb-2">Plan:</label>
              <select id="plan" className="w-full border-2 border-gray-300 rounded py-2 px-4" value={acDetails.plan} onChange={handleChange}>
                {availablePlans.map((plan) => (
                  <option key={plan.value} value={plan.value}>{plan.label}</option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="quantity" className="block font-semibold mb-2">Quantity:</label>
              <input
                id="quantity"
                type="text" // Allow full editability
                className="w-full border-2 border-gray-300 rounded py-2 px-4"
                value={acDetails.quantity === null ? '' : acDetails.quantity} // Display blank if null
                onChange={handleChange}
                onBlur={handleBlur} // Validate when losing focus
              />
            </div>
            <div>
              <label htmlFor="subscription_plan" className="block font-semibold mb-2">Subscription for M1 to M36 (Per Unit):</label>
              <input type="number" id="subscription_plan" className="w-full border-2 border-gray-300 rounded py-2 px-4" value={acDetails.subscription_plan} onChange={handleChange} onBlur={handleBlur3} />
            </div>
            <div>
              <label htmlFor="installetionCharge" className="block font-semibold mb-2">Installation Charges (Per Unit):</label>
              <input type="number" id="installetionCharge" className="w-full border-2 border-gray-300 rounded py-2 px-4" value={acDetails.installetionCharge} onChange={handleChange} onBlur={handleBlur1} />
            </div>
            <div>
              <label htmlFor="depositamount" className="block font-semibold mb-2">Refundable Deposit (Per Unit):</label>
              <input type="number" id="depositamount" className="w-full border-2 border-gray-300 rounded py-2 px-4" value={acDetails.depositamount} onChange={handleChange} onBlur={handleBlur2} />
            </div>

            <div>
              <label htmlFor="totalSubscription" className="block font-semibold mb-2">Total Subscription from M1 to M36:</label>
              <input type="number" id="totalSubscription" className="w-full border-2 border-gray-300 rounded py-2 px-4" value={acDetails.totalSubscription} onChange={handleChange} onBlur={handleBlur3} />
            </div>
            {/* price per unti */}
            {acDetails.plan === "3+2year" && (
              <>
                <div>
                  <label htmlFor="priceAfter3Years" className="block font-semibold mb-2">Subscription for M37 to M60 (Per unit):</label>
                  <input type="number" id="priceAfter3Years" className="w-full border-2 border-gray-300 rounded py-2 px-4" value={acDetails.priceAfter3Years} onChange={handleChange} readOnly />
                </div>
              </>
            )}
            <div>
              <label htmlFor="totalInstallation" className="block font-semibold mb-2">Total Installation Charges:</label>
              <input type="number" id="totalInstallation" className="w-full border-2 border-gray-300 rounded py-2 px-4" value={acDetails.totalInstallation} onChange={handleChange} readOnly />
            </div>
            <div>
              <label htmlFor="totalDeposit" className="block font-semibold mb-2">Total Refundable Deposit:</label>
              <input type="number" id="totalDeposit" className="w-full border-2 border-gray-300 rounded py-2 px-4" value={acDetails.totalDeposit} onChange={handleChange} readOnly />
            </div>
            {acDetails.plan === "3+2year" && (
              <>

                <div>
                  <label htmlFor="totalAfter3Years" className="block font-semibold mb-2">Total Subscription for M37 to M60:</label>
                  <input type="number" id="totalAfter3Years" className="w-full border-2 border-gray-300 rounded py-2 px-4" value={acDetails.totalAfter3Years} onChange={handleChange} readOnly />
                </div>
              </>
            )}
            {/* <div className="relative">
              <label htmlFor="approvalcode" className="block font-semibold mb-2">Approval Code</label>
              <input
                type="text"
                id="approvalcode"
                className="w-full border-2 border-gray-300 rounded py-2 px-4 pr-16" // Add padding to the right for the button
                value={acDetails.approvalcode}
                onChange={handleChange}
              />
              <button
                className="absolute right-2 top-1/2  bg-primary text-white rounded py-1 px-4 "
              // Button click handler
              >
                Apply
              </button>
            </div> */}

            <div>
              <label htmlFor="totalAmount" className="block font-semibold mb-2">Total Amount to be paid now:</label>
              <input type="number" id="totalAmount" className="w-full border-2 border-gray-300 rounded py-2 px-4" value={acDetails.totalAmount} onChange={handleChange} readOnly />
            </div>
          </div>
          <div>
            <button
              onClick={handleSave}
              className="mt-4 bg-primary text-white font-normal py-2 px-4 rounded"
            >
              Save AC Details
            </button>
          </div>
        </div>
      )}
    </div>
  );
}